import type { IPathBaseParam } from "./path";

import type { IApiResponse, IPagination, IPaginationParams } from "@/api";
import { createGetAllApi } from "@api/util/createGetAllApi";
import { createPostApi } from "@api/util/createPostApi";
import type {
  IMessageDto,
  IMessageResponse,
} from "@api/conversations/messages/types";
import type { IChannelsGetAllResponse } from "@api/channels/types";
import { markAsRead } from "@api/channels/messages/markAsRead/api";
import type { IUsersResponse } from "@api/users/types";

const getAllApis = createGetAllApi<
  IApiResponse<
    IPagination<
      IMessageResponse,
      { other_user: IUsersResponse; channel: IChannelsGetAllResponse }
    >
  >,
  IPathBaseParam,
  IPaginationParams
>("channels.messages");
const postApis = createPostApi<
  IApiResponse<IMessageResponse>,
  IPathBaseParam,
  IMessageDto
>("channels.messages");

export const messages = {
  ...getAllApis,
  ...postApis,
  markAsRead,
};
